export class VehiculoSiniestros {
    constructor(
        public FechaSiniestro?: Date,
        public Marca?: string,
        public Modelo?: string,
        public Placa?: string,
        public CodUnicoSiniestro?: number,
        public Estado?: string,
        public CedulaRuc?: string,
        public NombreAsegurado?: string,
        public Chasis?: string,
        public Motor?: string,
        public Migracion?: string,
        public CodigoTecni?: string,
        public TipoSiniestro?: string,
        public Amparo?: string,
        public NombreConductor?: string
    ) { }
}

export class CasaHabitacion {
    constructor(
        public FechaSiniestro?: Date,
        public DireccionAfectada?: string,
        public CodUnicoSiniestro?: number,
        public Estado?: string,
        public CedulaRuc?: string,
        public NombreAsegurado?: string,
        public Migracion?: string,
        public Tipo?: string,
        public CodigoTecni?: string
    ) { }
}

export class O2O {
    constructor(
        public FechaSiniestro?: Date,
        public NombrePaciente?: string,
        public Diagnostico?: string,
        public CodUnicoSiniestro?: number,
        public Estado?: string,
        public CedulaRuc?: string,
        public NombreAsegurado?: string,
        public Migracion?: string,
        public CodigoTecni?: string
    ) { }
}

export class Siniestros {
    constructor(
        public Vehiculos?: VehiculoSiniestros[],
        public CasaHabitacion?: CasaHabitacion[],
        public O2O?: O2O[],
        public OtrosRamos?: OtrosRamos[]
    ) { }
}

export class OtrosRamos {
    constructor(
        public FechaSiniestro?: Date,
        public DireccionAfectada?: string,
        public CodUnicoSiniestro?: number,
        public Proceso?: string,
        public Estado?: string,
        public CedulaRuc?: string,
        public NombreAsegurado?: string,
        public BienAfectado?: string,
        public TipoReclamo?: string,
        public Migracion?: string,
        public CodigoTecni?: string
    ) { }
}

export class SiniestralidadSiniestros {
    constructor(
        public Poliza?: string,
        public Aseguradora?: string,
        public Ramo?: string,
        public Inicio?: Date,
        public fin?: Date,
        public Produccion?: number,
        public Pendientes?: number,
        public ValorReserva?: number,
        public Cerrados?: number,
        public ValorIndemnizado?: number,
        public Siniestralidad?: number
    ) { }

}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/siniestros_entity.ts